import React from 'react';
import classNames from 'classnames';
import { BringzzText, BringzzIcon } from "@bringzz/components";
import { calculateFontSize } from './utils';
import CategorySlider from './components/CategorySlider';
import { useTranslation } from 'react-i18next';
import { useNavigation } from 'context/NavigationContext';

const INITIAL_HEADER_HEIGHT = 200;
const MIN_HEADER_HEIGHT = 120;
const TITLE_FONT_MAX = 24;
const TITLE_FONT_MIN = 16;
const PARAGRAPH_FONT_MAX = 13;
const PARAGRAPH_FONT_MIN = 8;

const getClassNames = (headerHeight) => {
    const baseClasses = 'fixed w-full px-4 top-0 z-50 bg-white transition-shadow duration-300 max-w-xl';
    const additionalClasses = headerHeight <= MIN_HEADER_HEIGHT
        ? 'flex flex-col items-center justify-center border-b shadow-md rounded-none space-y-4'
        : 'rounded-b-xl mx-2 flex flex-col py-4';
    const spaceBetweenY = headerHeight <= 120 ? 0 : headerHeight <= 140 ? 0 : headerHeight <= 160 ? 1 : headerHeight <= 180 ? 2 : 2;

    return `${baseClasses} ${additionalClasses} space-y-${spaceBetweenY}`;
};

const HeaderCategory = ({ headerHeight, title, searchData, setSearchData, SET_MIN_HEADER_HEIGHT, categories }) => {
    const { t } = useTranslation();
    const titleFontSize = calculateFontSize(headerHeight, TITLE_FONT_MAX, TITLE_FONT_MIN, INITIAL_HEADER_HEIGHT, MIN_HEADER_HEIGHT);
    const paragraphFontSize = calculateFontSize(headerHeight, PARAGRAPH_FONT_MAX, PARAGRAPH_FONT_MIN, INITIAL_HEADER_HEIGHT, MIN_HEADER_HEIGHT);
    const { backPress } = useNavigation();

    const handleCategorySelect = (category) => {
        setSearchData({
            method: "category",
            value: category.shortName,
            results: category.items
        });
    };

    return (
        <div className={getClassNames(headerHeight)} style={{ height: `${headerHeight}px` }}>
            <div className={classNames(
                'flex space-x-1 transition-all duration-300 transform',
                'justify-between w-full items-center'
            )}>
                <div>
                    <BringzzIcon folder='LineIcons' icon='IconChevronLeft' size='22' onClick={() => {
                        SET_MIN_HEADER_HEIGHT(48)
                        setSearchData(null)
                        backPress()
                    }} className='cursor-pointer' />
                </div>
                <div className='flex'>
                    <BringzzText tag='h2' style={{ fontSize: `${titleFontSize}px` }}>{t('component.search.header.browse')}</BringzzText>
                    <BringzzText tag='h2' className='text-magic-lilac' style={{ fontSize: `${titleFontSize}px` }}>{t('component.search.header.and')}</BringzzText>
                    <BringzzText tag='h2' style={{ fontSize: `${titleFontSize}px` }}>{t('component.search.header.search')}</BringzzText>
                </div>
                <div></div>
            </div>

            <div className='w-full'>
                <CategorySlider
                    categories={categories}
                    activeCategory={searchData?.value}
                    onCategorySelect={handleCategorySelect}
                />
            </div>

            {headerHeight > MIN_HEADER_HEIGHT && (
                <BringzzText tag='h4' className='font-normal transition-all duration-300' style={{ fontSize: `${paragraphFontSize}px` }}>
                    {t('component.search.header.description')}
                </BringzzText>
            )}
        </div>
    );
};

export default HeaderCategory;
